// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Yp5-","badges":"styles_badges__K6w77"};